import { AppEnvironment, AppName } from '@showbie/utilities/message';

/**
 * Version constant for features not yet released
 */
export const UNRELEASED_VERSION = '999.9.9';

/**
 * Minimum version requirements for features
 */
interface ShowbieFeatureVersionRequirement {
  ios: {
    qa: string;
    staging: string;
    production: string;
  };
  web: {
    qa: string;
    staging: string;
    production: string;
  };
}

export enum ShowbieFeatureName {
  QuizLibraryDownloadExport = 'quiz_library_download_export',
}

const FEATURE_VERSIONS: Record<
  ShowbieFeatureName,
  ShowbieFeatureVersionRequirement
> = {
  [ShowbieFeatureName.QuizLibraryDownloadExport]: {
    ios: {
      qa: '8.3.0',
      staging: '8.3.0',
      production: '8.3.0',
    },
    web: {
      qa: '6.5.1',
      staging: '6.5.1',
      production: '6.6.0',
    },
  },
};

/**
 * Get the minimum version required for a feature
 */
export function getMinVersionForFeature({
  feature,
  appName,
  appEnv,
}: {
  feature: ShowbieFeatureName;
  appName: AppName;
  appEnv: AppEnvironment;
}): string {
  const requirement = FEATURE_VERSIONS[feature];

  return requirement[appName][appEnv];
}
